module.exports = __webpack_public_path__ + "media/images/mobile/solutions/00-852945f7ec57f16fdba7f04e8a5bf0eb.jpg";